type NewRelicAttributeValue = string | number | null

export type NewRelicAttributes = Record<string, NewRelicAttributeValue>

export type NewRelicErrorContext =
  | 'ACCOUNT-SUSPENDED-PAGE'
  | 'APP'
  | 'AUTH-PAGES'
  | 'FIRST-PARTY-REVIEWS'
  | 'MARKET-INTELLIGENCE'
  | 'OMNI-LOCATION'
  | 'SOCIAL-MANAGEMENT'
  | 'WIDGET-PREVIEW'
  | 'WIDGETS'
  | 'BILLING-AND-PAYMENTS'
  | 'UPGRADE-PACKAGE'
  | 'REPORTS'

const TRACKED_CUSTOM_ATTRIBUTES: Set<string> = new Set()

export const NewRelic = {
  identify: ({
    userId,
    currentAccountId,
    originalAccountId,
    isMarqiiUser,
    isImpersonating,
  }: {
    userId: string
    currentAccountId: string
    originalAccountId: string | null
    isMarqiiUser: boolean
    isImpersonating: boolean
  }) => {
    window?.newrelic?.setUserId?.(userId)
    NewRelic.setCustomAttribute('currentAccountId', currentAccountId)
    NewRelic.setCustomAttribute('originalAccountId', originalAccountId)
    NewRelic.setCustomAttribute('isMarqiiUser', String(isMarqiiUser))
    NewRelic.setCustomAttribute('isImpersonating', String(isImpersonating))
  },

  setCustomAttribute: (name: string, value: NewRelicAttributeValue) => {
    if (value !== null) {
      TRACKED_CUSTOM_ATTRIBUTES.add(name)
    } else {
      TRACKED_CUSTOM_ATTRIBUTES.delete(name)
    }
    window?.newrelic?.setCustomAttribute?.(name, value)
  },

  clear: () => {
    window?.newrelic?.setUserId?.(null)
    TRACKED_CUSTOM_ATTRIBUTES.forEach((name) => {
      window?.newrelic?.setCustomAttribute?.(name, null)
    })
    TRACKED_CUSTOM_ATTRIBUTES.clear()
  },

  addPageAction: (name: string, attributes?: NewRelicAttributes) => {
    window?.newrelic?.addPageAction?.(name, attributes)
  },

  noticeError: (
    errorContext: NewRelicErrorContext,
    errorOrMessage: Error | string,
    attributes?: NewRelicAttributes,
  ) => {
    const error = typeof errorOrMessage === 'string' ? new Error(errorOrMessage) : errorOrMessage
    window?.newrelic?.noticeError?.(error, { errorContext, ...attributes })
  },
}
